import axios from 'axios'
import store from '../store'
import router from '../router'

export default () => {
    const locationHostnameDevelopment =  'localhost:8000'
    //const locationHostnameDevelopment =  'unetworld.com'
    const locationHostnameProduction  =  'unetworld.com'
    const locationHostname = location.host === 'localhost:8080' ? locationHostnameDevelopment : locationHostnameProduction
    const instance = axios.create({
        baseURL: location.protocol +'//' + locationHostname,
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-with': 'XMLHttpRequest'
        }
    })
    instance.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (401 === error.response.status) {
            store.commit('removeToken')
            router.push({ name: 'Login' })
        }
        return Promise.reject(error)
    })
    return instance
}



// WEBPACK FOOTER //
// ./src/api/api.js